if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.parent = this.closest('.product-recommendations--parent');
    }

    fetchProducts() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            
            this.innerHTML = recommendations.innerHTML;

            try {
              const holderId = this.dataset.upsellHolderId;
              if (holderId) {
                const upsellHolder = document.getElementById(holderId);

                if (upsellHolder && upsellHolder.firstElementChild) {
                  const upsellElement = upsellHolder.firstElementChild;
                  const productList = this.querySelector('.cart-drawer--recommendations--products');

                  if (productList) {
                    const secondPosition = productList.children[1];

                    if (secondPosition) {
                      productList.insertBefore(upsellElement, secondPosition);
                    } else {
                      productList.appendChild(upsellElement);
                    }
                    upsellHolder.remove();
                  }
                }
              }
            } catch (e) {
              console.error('Error moving upsell product:', e);
            }

            if (this.parent) {
              this.parent.classList.add('product-recommendations--full');

              if (document.body.classList.contains('open-cart')) {
                this.parent.classList.add('active');
              }
            }
          }

          this.classList.add('product-recommendations--loaded');
        })
        .catch(e => {
          console.error(e);
        });
    }

    connectedCallback() {
      this.fetchProducts();
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}